import { CoverageType, PolicyType, PolicyTypeRenameRequest, PolicyTypeUpdateRequest } from '@/types/PolicyType';
import { Service } from './api';

class PolicyTypeService extends Service {
    async LoadPolicyTypes(): Promise<Array<PolicyType>> {
        return await this.get<PolicyType[]>('/v1/admin/policy-type').then(this.handleResponse);
    }

    async GetDistinctCoverageTypes(): Promise<Array<CoverageType>> {
        return await this.get<CoverageType[]>('/v1/reference/policy-type/coveragetypes').then(this.handleResponse);
    }

    async UpdatePolicyTypeDescription(src: PolicyType): Promise<void> {
        return await this.put<void>('/v1/admin/policy-type/description', src).then(this.handleResponse);
    }

    async UpdatePolicyTypeCoverageType(src: PolicyTypeUpdateRequest): Promise<void> {
        return await this.put<void>('/v1/admin/policy-type/coveragetype', src).then(this.handleResponse);
    }

    async RenameCoverageType(src: PolicyTypeRenameRequest): Promise<void> {
        return await this.patch<void>('/v1/admin/coveragetype/rename', src).then(this.handleResponse);
    }

    async SetMainPolicyTypeFlag(policyType: string, value: boolean): Promise<void> {
        return await this.patch<void>(`/v1/admin/policy-type/${policyType}/mainpolicyflag`, { flag: value }).then(this.handleResponse);
    }

    async SetCasualtyFlag(policyType: string, value: boolean): Promise<void> {
        return await this.patch<void>(`/v1/admin/policy-type/${policyType}/casualtyflag`, { flag: value }).then(this.handleResponse);
    }
    async SetPropertyFlag(policyType: string, value: boolean): Promise<void> {
        return await this.patch<void>(`/v1/admin/policy-type/${policyType}/propertyflag`, { flag: value }).then(this.handleResponse);
    }

    async CreateCoverageType(coverageType: string): Promise<void> {
        return await this.post<void>('/v1/admin/coveragetype', { coverageType }).then(this.handleResponse);
    }

    async DeleteCoverageType(coverageType: string): Promise<void> {
        return await this.delete<void>(`/v1/admin/coveragetype/${encodeURIComponent(coverageType)}`).then(this.handleResponse);
    }

    async UpdateCoverageTypeProduct(coverageTypeId: number, productId: number): Promise<void> {
        return await this.patch<void>('/v1/admin/coveragetype/product', { coverageTypeId, productId }).then(this.handleResponse);
    }
}

export const policyTypeService = new PolicyTypeService();
